import jsQR from 'jsqr';
import type { ScannerAdapter, ScannerResult } from '@/shared/camera/scanner-adapter';

export class JsQrScannerAdapter implements ScannerAdapter {
  readonly id = 'jsqr';

  isSupported() {
    return Promise.resolve(true);
  }

  scan(source: ImageBitmapSource): Promise<ScannerResult[]> {
    const canvas = readCanvas(source);

    if (!canvas) {
      return Promise.resolve([]);
    }

    const context = canvas.getContext('2d', { willReadFrequently: true });

    if (!context) {
      return Promise.resolve([]);
    }

    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    const result = jsQR(imageData.data, imageData.width, imageData.height);

    return Promise.resolve(result?.data ? [{ format: 'qr_code', rawValue: result.data }] : []);
  }
}

function readCanvas(source: ImageBitmapSource) {
  if (typeof HTMLCanvasElement !== 'undefined' && source instanceof HTMLCanvasElement) {
    return source;
  }

  return null;
}
